import { createContext, ReactNode } from 'react'

import useQuoteBuilder from '../CampaignQuoteBuilder/hooks/useQuoteBuilder'

export type DefaultContext<Payload = any> = {} & Payload

const data: DefaultContext = {}

export type QuoteBuilderContextPayload = {
  [key: string]: any,
}

export const QuoteBuilderContext = createContext<QuoteBuilderContextPayload>(data)

interface QuoteBuilderContextProviderProps {
  children: ReactNode,
  value: ReturnType<typeof useQuoteBuilder>,
}

const QuoteBuilderContextProvider = (props: QuoteBuilderContextProviderProps) => {
  const { children, value } = props

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const builderContext = {
    ...value,
  }

  return (
    <QuoteBuilderContext.Provider value={builderContext}>
      {children}
    </QuoteBuilderContext.Provider>
  )
}

export default QuoteBuilderContextProvider
